"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const map_component_1 = require("../../map.component");
const map_service_1 = require("../../../../commons/map.service");
const base_annot_component_1 = require("./base_annot.component");
const Constants_1 = require("../../../../commons/Constants");
const Cesium = window.Cesium;
var b64toBlob = require('b64-to-blob');
class BaseMeasure extends base_annot_component_1.BaseAnnotViewer {
    /*
        BaseMeasureComponent
        --------------------
        Deals with all mouse and screen interaction
    
      */
    constructor(route, router, snackBar, dialog, mapComp, mapService, mappingHelper, entityHelper, applicationEvents, epsgHelper, fileManager) {
        super(route, router, snackBar, dialog, mapComp, mapService, mappingHelper, entityHelper, applicationEvents, epsgHelper, fileManager);
        this.route = route;
        this.router = router;
        this.mapComp = mapComp;
        this.mapService = mapService;
        this.mappingHelper = mappingHelper;
        this.entityHelper = entityHelper;
        this.applicationEvents = applicationEvents;
        this.epsgHelper = epsgHelper;
        this.fileManager = fileManager;
        this.debug = Constants_1.Constants.debug_off;
        this.vertical_offset = 0;
        this.sumOfHeights = 0;
        this.batchSize = 0;
        this.timeout = 10000; // in ms
        this.takingScreenShot = false;
        this.selectedEPSG = '4326';
        this.unit = 'meter';
        this.FEET = map_service_1.MapService.FEET;
        this.picked3DPositionIsValid = false;
        this.feetValue = 0.3048;
        this.firstTime3Dpoint = false;
        this.pointsCopy = [];
        // @haresh, this variable needs to be documented
        this.currentPointsIndex = 0;
        // measuredValue = 0
        this.errMsg = '';
        this.Cesium = Cesium;
        // protected currentPointsIndexLineWidth: number;
        // protected currentPointsIndexColor: any;
        // category suggestions for shapes
        this.categoriesSuggestions = [{ label: 'Important' }, { label: 'Urgent' }, { label: 'Damaged' }, { label: 'Good' }, { label: 'Bad' },];
        // screen capture
        this.screenCapture = false;
        this.screenCaptureElement = null;
        this.dragging = false;
        // console.log ( '%c base_measure.comp %c constructor', Constants._yellow, Constants._yellow, this );
        this.translate.get(['MAP.ADD_POINT', 'MAP.RIGHT_CLICK_CANCEL', 'MAP.LENGTH', 'MAP.HORIZONTAL_DIST', 'MAP.HEIGHT_DIF', 'MAP.SLOPE', 'MAP.AZIMUTH', 'MAP.SEGMENT_INFO', 'MAP.CONTROLS', 'MAP.TOTAL_LENGTH', 'MAP.VOLUME_TOOLTIP']).subscribe(p => {
            this.ADD_POINT = p['MAP.ADD_POINT'] ? p['MAP.ADD_POINT'] : 'Click to add point';
            this.VOLUME_TOOLTIP = p['MAP.VOLUME_TOOLTIP'] ? p['MAP.VOLUME_TOOLTIP'] : 'Click on Calculate Volume';
            this.RIGHT_CLICK_CANCEL = p['MAP.RIGHT_CLICK_CANCEL'] ? p['MAP.RIGHT_CLICK_CANCEL'] : 'Right click or Stop button to cancel';
            this.LENGTH = p['MAP.LENGTH'] ? p['MAP.LENGTH'] : 'Length';
            this.HORIZONTAL_DIST = p['MAP.HORIZONTAL_DIST'] ? p['MAP.HORIZONTAL_DIST'] : 'Horizontal Distance';
            this.HEIGHT_DIF = p['MAP.HEIGHT_DIF'] ? p['MAP.HEIGHT_DIF'] : 'Height Difference';
            this.SLOPE = p['MAP.SLOPE'] ? p['MAP.SLOPE'] : 'Slope';
            this.AZIMUTH = p['MAP.AZIMUTH'] ? p['MAP.AZIMUTH'] : 'Azimuth';
            this.SEGMENT_INFO = p['MAP.SEGMENT_INFO'] ? p['MAP.SEGMENT_INFO'] : 'Segment information';
            this.CONTROLS = p['MAP.CONTROLS'] ? p['MAP.CONTROLS'] : 'Controls';
            this.TOTAL_LENGTH = p['MAP.TOTAL_LENGTH'] ? p['MAP.TOTAL_LENGTH'] : 'Total Length';
        });
    }
    // generic mouse handler (handles click coming through Angular, not Cesium)
    clickedMap(movement, rightClick, checkedPosition) {
        if (this.debug) {
            console.log('%c base_measure.comp :: clickedMap()', this.debugStyleMouse, movement, rightClick);
        }
        if (rightClick) {
            return this.onRightClick(movement, checkedPosition);
        }
        // do rudementary clicks, but push them back to inspect_comp
        this.onLeftClick(movement, checkedPosition);
        return map_component_1.ClickDisplay.None;
    }
    // left-click handler (Angular2 clicks, not Cesium)
    onLeftClick(movement, checkedPosition) {
        if (this.debug) {
            console.log('%c base_measure.comp :: onLeftClick()', this.debugStyleMouse, movement, checkedPosition);
        }
        // this one is never really used? (@haresh?)
        // var isDeselect = false
        // should also note that state should never be a negative, as in isDeselect. Something is either selected or not
        // thinking we're unselecting anything if previously anything was selected? (rather than checking if we clicked the selected and the return blank?)
        /*if (Cesium.defined(this.selectedPlane)) {
          if ( this.debug ) { console.log ( 'base_measure.comp :: onLeftClick() -> selectedPlane'); }
          this.selectedPlane.material = Cesium.Color.RED.withAlpha(0.5);
          this.selectedPlane.outlineColor = Cesium.Color.WHITE;
          this.selectedPlane = undefined;
    
          // this one is never really used? (@haresh?)
          // isDeselect = true
        }*/
        // see if we clicked on something
        // var features = this.mapService.viewer.scene.drillPick(movement.position, 2, 10, 10);
        // reset pickedObject
        var pickedObject = undefined;
        // anything found?
        if (checkedPosition.tileset) {
            pickedObject = checkedPosition.tileset;
        }
        // if ( this.debug ) { console.log ( '%c base_measure.comp :: onLeftClick() :: features found', this.debugStyleMouse, features, pickedObject); }
        // var pickedObject = this.mapService.viewer.scene.pick(movement.position);
        /*
        // not sure what these are? Are 3d a normal object, while if it's not, it's maybe a JSONGeo or a label or something? (@haresh?)
        if (this.mapService.viewer.scene.pickPositionSupported && pickedObject && pickedObject.content && pickedObject.content._tileset) {
          this.pickedFeatureIs3D = pickedObject
        } else {
          this.pickedFeatureIs3D = undefined
        }
    
        if (this.pickedFeatureIs3D) {
          if (this.pickedFeatureIs3D.content._pointCloud) {
            var rtcCenter = this.pickedFeatureIs3D.content._pointCloud._rtcCenter;
            this.geometricError = this.pickedFeatureIs3D.content._pointCloud.geometricError;
            var cartesian = this.mapService.viewer.scene.pickPosition(movement.position);
            if (this.geometricError < 0.5) {
    
              // what does this check? Why 200? (@haresh?)
              if (Math.abs(rtcCenter.z - cartesian.z) < 200) {
                this.picked3DPositionIsValid = true;
              } else {
                this.picked3DPositionIsValid = false
              }
            } else {
              this.picked3DPositionIsValid = true
            }
          } else {
            this.picked3DPositionIsValid = true;
          }
        } else {
          this.picked3DPositionIsValid = false
        }
    */
        // what does this do? (@haresh?)
        // this.mapService.viewer.scene.screenSpaceCameraController.enableInputs = true;
        // pick the coords from the mouse click (screen coords)
        // var coords = this.mapService.viewer.scene.pickPosition(movement.position);
        // don't understand how this this.pos1 and this.pos2 hang together. @haresh?
        // if (this.mouseMode == 'MODE_ADD') {
        //   this.pos1 = checkedPosition.coords;
        // }
        // if ( this.debug ) { console.log ( '%c base_measure.comp :: onLeftClick() ->', this.debugStyleMouse, pickedObject, this.pickedFeatureIs3D, this.picked3DPositionIsValid, this.pos1); }
        /*
            if (this.mouseMode == 'MODE_ADD' && (!this.draggableHandleObj || this.annotation['annotationMode'] == 'flyToLine' ) && !this.mapComp.flyingToLine ) {
        
              // call override function?
              this.setAnnotationProps();
        
              //is this the selected point?
              this.addPoint(checkedPosition.coords, true)
            }
            this.setVerticalOffset();
            */
    }
    // Cesium left-down-click (Cesium handler)
    onLeftDownClick(movement) {
        if (this.debug) {
            console.log('%c base_measure.comp :: onLeftDownClick()', this.debugStyleMouse);
        }
        let check = this.checkedMousePosition(movement);
        // record position on down-click only (not up-click)
        if (check.coords) {
            this.screenCoordsCartesian = check.coords;
        }
        if (this.interactionMode == 'create') {
            this.isDragging = true;
            return;
        }
        // if there's a drag handle (for a point)
        if (check.handle && !this.annotation['lockPositions']) {
            // this is our selected object
            this.draggableHandleObj = check.handle; // this.mapService.viewer.entities.getById(check.handle.id);
            // dragHandleStart won't kick in until actual mouse movement
            this.shapeMaker.dragHandleStart(check, this.useGhostlines);
            this.isDragging = true;
            this.enableCameraMotion(false);
            if (this.debug) {
                console.log('%c base_measure.comp :: onLeftDownClick() HANDLE', this.debugStyleMouse, this.draggableHandleObj);
            }
        }
        else 
        // if there's an action handle
        if (check.action) {
            if (check.action.type == 'deletehandle') {
                if (this.debug) {
                    console.log('%c base_measure.comp :: onLeftDownClick() DELETEHANDLE', this.debugStyleMouse, this.draggableHandleObj);
                }
            }
            else {
                // this is our selected object
                this.draggableHandleObj = check.action; // this.mapService.viewer.entities.getById(check.action.id);
                this.shapeMaker.dragHandleStart(check, this.useGhostlines);
                this.isDragging = true;
                this.enableCameraMotion(false);
                if (this.debug) {
                    console.log('%c base_measure.comp :: onLeftDownClick() ADDHANDLE', this.debugStyleMouse, this.draggableHandleObj);
                }
            }
        }
        else if (check.feature) {
            if (check.feature.type == 'poi' && !this.annotation['lockPositions']) {
                this.isDragging = true;
                this.enableCameraMotion(false);
                this.draggableHandleObj = check.feature;
                if (this.debug) {
                    console.log('%c base_measure.comp :: onLeftDownClick() FEATURE POI', this.debugStyleMouse, check);
                }
            }
            else {
                if (this.debug) {
                    console.log('%c base_measure.comp :: onLeftDownClick() FEATURE', this.debugStyleMouse, check);
                }
            }
        }
        else if (check.tileset) {
            if (this.debug) {
                console.log('%c base_measure.comp :: onLeftDownClick() TILESET', this.debugStyleMouse);
            }
        }
        else {
            if (this.debug) {
                console.log('%c base_measure.comp :: onLeftDownClick() found nothing', this.debugStyleMouse);
            }
        }
        // if ( this.debug ) { console.log ( '%c base_measure.comp :: onLeftDownClick() END', this.debugStyleMouse, this.mode, checkedPosition.feature, this.draggableHandleObj);}
    }
    // Cesium left-up-click
    onLeftUpClick(movement) {
        // this.debug = true;
        const ww = 'background-color:red;color:white;font-size:15px;';
        // reset the mouse coordinates
        this.hasCheckedMousePosition = false;
        // check what's at the current mouse position
        // let check = this.checkedMousePosition ( movement );
        // check, but no cache
        let check = this.mappingHelper.checkMousePosition(movement);
        let props = check.props;
        if (this.debug) {
            console.log('%c base_measure.comp :: onLeftUpClick() A', this.debugStyleMouse, this.type, this.isDragging ? 'DRAGGING' : 'CLICKING', this.shapeMaker.mouseDragMovements ? 'drag_moving' : 'no_drag', this.interactionMode, this.draggableHandleObj);
        }
        if (this.debug) {
            console.log('%c base_measure.comp :: onLeftUpClick() B', this.debugStyleMouse, check.coords ? 'HAVE_COORDS' : 'N_COORDS', movement, check, props);
        }
        if (this.draggableHandleObj && this.draggableHandleObj['__type'] && this.draggableHandleObj.__type == 'poi') {
            check.feature = this.draggableHandleObj;
        }
        if (check.coords && this.interactionMode == 'create') {
            if (this.shapeMaker.mouseDragMovements) {
                if (this.debug) {
                    console.log('%c base_measure.comp :: onLeftUpClick() CREATE dragged', this.debugStyleMouse);
                }
            }
            else {
                if (this.debug) {
                    console.log('%c base_measure.comp :: onLeftUpClick() CREATE clicked', this.debugStyleMouse);
                }
                this.clickWhileCreateShape(check);
            }
        }
        else 
        // an action handle? (drag new, or delete)
        if (check.action) {
            // is there a selected object? (probably a handle entity that's moved)
            if (this.draggableHandleObj) {
                if (this.shapeMaker.mouseDragMovements) {
                    // dragged handle
                    // console.log ( ' - action handle DRAGGED' );
                    this.insertPointAt(props.pointRef, check);
                }
                else {
                    // clicked handle
                    // console.log ( ' - action handle CLICKED' );
                    if (check.action.type == 'deletehandle') {
                        this.deletePoint(props.pointRef, check);
                    }
                }
                // auto-calculate?
                if (this.autoCalculate) {
                    this.calculate();
                }
            }
            else {
                if (this.debug) {
                    console.log('%c base_measure.comp :: onLeftUpClick()  ACTION HANDLE in different shape', ww);
                }
                this.shapeMaker.selectShape(props.shapeRef, this.shapes);
                // console.log ( '%c base_annot %c selectedShape :: onLeftUpClick() 4', this.debugStyle, Constants._red, this.shapeMaker.selectedShape );
            }
            if (this.debug) {
                console.log('%c base_measure.comp :: onLeftUpClick()  ACTION', this.debugStyleMouse, check.action);
            }
        }
        else 
        // any other handle?
        if (check.handle) {
            // this.isDragging = false;
            // is there a selected object? (probably a handle entity that's moved or clicked)
            if (this.draggableHandleObj) {
                if (this.shapeMaker.mouseDragMovements) {
                    if (this.debug) {
                        console.log('%c base_measure.comp :: onLeftUpClick()  HANDLE something has been DRAGGED', ww);
                    }
                }
                else {
                    if (this.debug) {
                        console.log('%c base_measure.comp :: onLeftUpClick()  HANDLE something has been CLICKED', ww);
                    }
                    this.shapeMaker.selectPoint(props.shapeRef, props.pointRef);
                }
                this.endHandle(check);
            }
            else {
                if (this.debug) {
                    console.log('%c base_measure.comp :: onLeftUpClick()  HANDLE in different shape', ww);
                }
                this.shapeMaker.selectShape(props.shapeRef, this.shapes);
                // console.log ( '%c base_annot %c selectedShape :: onLeftUpClick() 3', this.debugStyle, Constants._red, this.shapeMaker.selectedShape );
            }
            if (this.debug) {
                console.log('%c base_measure.comp :: onLeftUpClick()  HANDLE', this.debugStyleMouse);
            }
        }
        else 
        // did we click on a feature?
        if (check.feature) {
            const s = 'background-color:red;color:white;font-size:15px;';
            if (this.debug) {
                console.log('%c base_measure.comp :: onLeftUpClick() feature', s, check, this.annotation);
            }
            // is it a feature linked to an annotation?
            if (check.props && check.props.annotationRef) {
                // is it a shape in the current annotation?
                if (check.props.annotationRef == this.currentAnnotationRef) {
                    if (this.debug) {
                        console.log('%c base_measure.comp :: onLeftUpClick()  FEATURE same annotation', s);
                    }
                    // and it's a different shape from the currently selected one ...
                    if (check.props.shapeRef !== this.shapeMaker.selectedShape) {
                        if (this.debug) {
                            console.log('%c base_measure.comp :: onLeftUpClick()  -- different shape', s);
                        }
                        this.shapeMaker.unselectShape(this.shapes);
                        this.shapeMaker.selectShape(check.props.shapeRef, this.shapes);
                        // this.flyTo ( this.shapeMaker.selectedShape );
                    }
                    else {
                        if (this.debug) {
                            console.log('%c base_measure.comp :: onLeftUpClick()  -- same shape', s);
                        }
                    }
                }
                else {
                    // it's a different annotation, so unload the current, and load in the new ...
                    let a = this.mapComp.inspectorComp.originalAnnots.find(c => c.id == props.annotationRef);
                    if (this.debug) {
                        console.log('%c base_measure.comp :: onLeftUpClick()  OTHER FEATURE different annotation', s);
                    }
                    if (a) {
                        // close and reset stuff
                        this.beforeUpdateShape();
                        this.clickCloseAnnotation();
                        // if a different feature in a different annotation, choose that one
                        this.mapComp.inspectorComp.setSelected(null, true, 'base_measure:onLeftUpClick() A');
                        // this.updateShape();
                        this.mapComp.inspectorComp.setSelected(a, true, 'base_annot:onLeftUpClick() B');
                    }
                }
            }
            else if (check.feature['type'] && check.feature['type'] == 'poi') {
                if (!this.annotation['lockPositions']) {
                    let pos = check.currentCoord.position;
                    let lon = Cesium.Math.toDegrees(pos.longitude);
                    let lat = Cesium.Math.toDegrees(pos.latitude);
                    this.annotation['llng'] = lon;
                    this.annotation['llat'] = lat;
                    this.annotation['lheight'] = pos.height;
                    this.updateAnnotationCameraCoords();
                }
                // console.log ( "!!!!!!!!!!!!!!!!!!! POI", pos, lon, lat, this.annotation );
            }
        }
        else {
            this.shapeMaker.unselectPoint();
            this.endHandle(check);
            if (this.debug) {
                console.log('%c base_measure.comp :: onLeftUpClick()  other', this.debugStyleMouse, check);
            }
        }
        if (this['profile']) {
            this['calculateProfiler']();
        }
        // reset drags and mouse handlers
        this.shapeMaker.dragHandleEnd(check);
        this.isDragging = false;
        // reset a few features after a click
        this.mapService.viewer.scene.screenSpaceCameraController.enableInputs = true;
        this.mapService.viewer.picked = false;
        this.enableCameraMotion(true);
        // reset the cached check object
        this.hasCheckedMousePosition = null;
        // this.debug = false;
    }
    endHandle(check) {
        let props = check.props;
        // mouse dragged?
        if (this.draggableHandleObj) {
            props = this.entityHelper.getEntityProperties(this.draggableHandleObj.id);
            check.handle = this.draggableHandleObj;
            check.props = props;
        }
        // reset drags and mouse handlers
        this.shapeMaker.dragHandleEnd(check);
        if (props) {
            let positions = this.shapeMaker.getPositionsFromHandles(props.shapeRef);
            // update positions of our shape object
            this.shapes = this.shapeMaker.updateShapesPositions(this.shapes, props.shapeRef, positions);
            // let entityRef = this.testEntityRefIntegrity ( props.shapeRef, props.entityRef );
            let entityRef = this.entityHelper.getEntityId(this.currentAnnotationRef, props.shapeRef);
            // update positions of the shape in the map
            this.entityHelper.entityChange('coords', entityRef, positions);
            // auto-calculate?
            if (this.autoCalculate) {
                this.calculate();
            }
            // quickly unselect and select again (to redraw and recalculate all points)
            this.shapeMaker.unselectShape(this.shapes);
            this.shapeMaker.selectShape(props.shapeRef, this.shapes);
            this.annotationUpdated();
        }
        // dragged handle
        // console.log ( ' END - handle RELEASED', props, check, this.draggableHandleObj, this.shapeMaker.mouseDragMovements );
    }
    // Angular2 right-click
    onRightClick(movement, checkedPosition) {
        if (this.debug) {
            console.log('%c base_measure.comp :: handleRightClick()', this.debugStyleMouse);
        }
        // if (this.mode === 'volume' || this.mode === 'flyToLine') {
        //   return;
        // }
        // stopping creation mode
        if (this.interactionMode == 'create') {
            this.endCreateShape();
        }
        return map_component_1.ClickDisplay.None;
    }
    // Cesium mouse-move
    onMouseMove(movement) {
        // this.shapeMaker.ghostLabelsOff();
        //if ( this.debug ) { console.log ( '%c base_measure.comp :: onMouseMove()', this.debugStyleMouse, movement ); }
        let position = null; // old way --- this.mappingHelper.pickPositionSnapToTileset ( movement.endPosition );
        if (this.mappingHelper.cached && this.mappingHelper.cached.coords) {
            position = this.mappingHelper.cached.coords;
        }
        //if ( this.debug ) { console.log ( '%c base_measure.comp :: onMouseMove() POS', this.debugStyleMouse, position, this.draggableHandleObj, this.interactionMode, this.isDragging ); }
        // if position is null, just return (most often if you move or click outside the Cesium globe)
        if (!position) {
            return;
        }
        if (this.mouseCursor && position && position.x) {
            this.mouseCursor.position = position;
        }
        // are we creating a shape?
        if (!this.draggableHandleObj && this.interactionMode == 'create') {
            if (this.isDragging) {
                this.shapeMaker.dragHandle();
            }
            this.shapeMaker.updateGhostlinePositions(this.creationPoints, position);
        }
        else {
            // have we selected an object on the map?
            if (this.isDragging && this.draggableHandleObj) {
                // update its position
                this.draggableHandleObj.position = position;
                // update the global one while dragging
                this.screenCoordsCartesian = position;
                if (this.draggableHandleObj['type'] && this.draggableHandleObj['type'] == 'poi') {
                    // pin moving around
                }
                else {
                    // anything else (probably a handle) moving around
                    this.shapeMaker.dragHandle();
                }
            }
        }
        /*
    
        this works (so keep it here for now), but is temporarily turned off as it kinda makes it harder to navigate
    
        for (const [idx, e] of this.shapeMaker.getAddhandleLabels() ) {
          if ( e.handle ) {
            this.mapComp.updateInfoBox ( idx, this.shapeMaker.getLabel( e.handle ) );
          }
        };
        */
        if (this.mapComp.ghostlabelOneIdx) {
            this.mapComp.updateInfoBox(this.mapComp.ghostlabelOneIdx, this.shapeMaker.getGhostlabelOne());
        }
        if (this.mapComp.ghostlabelTwoIdx) {
            this.mapComp.updateInfoBox(this.mapComp.ghostlabelTwoIdx, this.shapeMaker.getGhostlabelTwo());
        }
        this.mapComp.refreshInfoBoxes();
    }
    canvasClick() { }
    canvasSizerDoing(e = null) {
        if (!this.dragging) {
            return;
        }
        let pos = this.screenCaptureElement.getBoundingClientRect();
        let top = pos.top;
        let left = pos.left;
        let height = e.clientY - top;
        let width = e.clientX - left;
        this.screenCaptureElement.style.height = Math.round(height) + 'px';
        this.screenCaptureElement.style.width = Math.round(width) + 'px';
        // console.log('@@@ doing',top,left,height, width, e);
    }
    canvasSizerDo(e = null) {
        let find = document.getElementById("screen-grabber");
        if (find) {
            this.screenCaptureElement = find;
            this.dragging = true;
        }
    }
    canvasSizerDone(e = null) {
        this.dragging = false;
    }
    captureScreenshot() {
        this.screenCapture = !this.screenCapture;
    }
    saveScreenshot() {
        let me = this;
        let find = document.getElementById("screen-grabber");
        if (find) {
            this.screenCaptureElement = find;
        }
        let pos = this.screenCaptureElement.getBoundingClientRect();
        this.screenCapture = false;
        // var canvas = this.mapService.viewer.scene.canvas;
        Constants_1.Constants.showHangOn();
        this.mapService.viewer.render();
        // canvas is 3D, so first save a blob bitstream (screenshot)
        this.mapService.viewer.scene.canvas.toBlob(function (blob) {
            // convert blob to an image
            var img = new Image();
            img.onload = function () {
                // temporary place to put the image (for cropping/scaling)
                let tempCanvas = document.createElement("canvas");
                let tempCtx = tempCanvas.getContext("2d");
                // make it the same size as the originasl
                tempCanvas.width = me.mapService.viewer.scene.canvas.width;
                tempCanvas.height = me.mapService.viewer.scene.canvas.height;
                // final canvas to export
                let finalCanvas = document.createElement("canvas");
                let finalCtx = finalCanvas.getContext("2d");
                // make the final the size of the cropped image
                finalCanvas.width = pos.width;
                finalCanvas.height = pos.height;
                // draw the new image into the cropping canvas
                tempCtx.drawImage(img, 0, 0);
                // pull the cropped version out (64px offset between cesium canvas and the screen coordinates)
                let data = tempCtx.getImageData(pos.left, pos.top - 64, pos.width, pos.height);
                // and put it into the final canvas
                finalCtx.putImageData(data, 0, 0);
                Constants_1.Constants.hideHangOn();
                var osd_img = finalCanvas.toDataURL('image/png');
                osd_img = osd_img.replace(/^data:image\/(png|jpeg|jpg);base64,/, '');
                var contentType = 'image/png';
                // pop it into a new Transform object
                let t = me.mapService.getNewTransform();
                t['screenshotByteCharacters'] = b64toBlob(osd_img, contentType);
                // clean up
                tempCanvas.remove();
                finalCanvas.remove();
                console.log('!!!!!', t);
                // send it for processing / attachment
                me.mapService.onSingleImageForAttachementChange.next(t);
            };
            // start the conversion
            img.src = URL.createObjectURL(blob);
        });
        // var ctx = canvas.getContext("2d");
        // console.log('@@@@@@@', canvas, ctx, pos );
        // console.log ( "@@@@", this.viewer.drawer.canvas );
        // var data = ctx.getImageData(pos.left, pos.top, pos.width, pos.height);
        // this.mapService.onSingleImageForAttachementChange.next(data);
        /*
        
        var compositeOperation = ctx.globalCompositeOperation;
    
        ctx.globalCompositeOperation = "destination-over";
        ctx.fillStyle = "#800000";
        ctx.fillRect(0,0,canvas.width,canvas.height);
    
        var tempCanvas = document.createElement("canvas"),
        tempCtx = tempCanvas.getContext("2d");
        tempCanvas.width = 450;
        tempCanvas.height = 180;
    
        tempCtx.drawImage(canvas,0,0);
    
        tempCanvas.toBlob(function(blob){
          this.mapService.onSingleImageForAttachementChange.next(blob);
        });
    
    */
        /*
            var osd_img: string = this.viewer.drawer.canvas.toDataURL('image/png');
            osd_img = osd_img.replace(/^data:image\/(png|jpeg|jpg);base64,/, '');
            var contentType = 'image/png';
            this.data.img.screenshotByteCharacters = b64toBlob(osd_img, contentType);
            this.mapService.onSingleImageForAttachementChange.next(this.data.img);
        */
    }
    updateAnnotationCameraCoords() {
        this.mapComp.inspectorComp.updateAnnotationCoordinateCamera(this.annotation);
        this.save();
    }
    setVerticalOffset() {
        if (this.debug) {
            console.log('base_measure.comp :: setVerticalOffset()');
        }
        if (this.pickedFeatureIs3D && this.pickedFeatureIs3D.content._tileset.id) {
            this.vertical_offset = this.pickedFeatureIs3D.content._tileset.id;
        }
        else {
            this.vertical_offset = 0;
        }
    }
    setScreenCoords(coords) {
        if (!coords)
            return;
        var carto = Cesium.Cartographic.fromCartesian(coords);
        if (!carto)
            return;
        if (this.sourceProjection) {
            // Projx4.defs('EPSG:31467', '+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=3500000 +y_0=0 +ellps=bessel +towgs84=598.1,73.7,418.2,0.202,0.045,-2.455,6.7 +units=m +no_defs');
            let longLat = this.epsgHelper.convert(this.geographicProjection, this.sourceProjection, [carto.longitude * 180 / Math.PI, carto.latitude * 180 / Math.PI]);
            this.screenCoords = {
                lat: longLat[1],
                lng: longLat[0],
                height: this.mappingHelper.getLocalisedValue(carto.height - this.vertical_offset, this.annotation),
                coord: carto
            };
        }
        else {
            this.screenCoords = {
                lat: carto.latitude,
                lng: carto.longitude,
                height: this.mappingHelper.getLocalisedValue(carto.height - this.vertical_offset, this.annotation),
                coord: carto
            };
        }
    }
    // calculations
    startCalculating(total = 1) {
        this.calculating = true;
        this.currentCalc = 0;
        this.totalCalc = total;
    }
    endCalculating() {
        this.calculating = false;
    }
    cancelCalculating() {
        this.calculating = false;
    }
    updateCalculationProcess(current) {
        this.currentCalc = current;
        this.percentFinished = ((this.currentCalc * 100) / this.totalCalc);
    }
}
exports.BaseMeasure = BaseMeasure;
